<template>
  <div>
    <!-- AS Header -->
    <div id="header_main" v-if="tenant === 'as'">
      <div id="header_main_inner" class="container_as">
        <div id="header_main_alpha_as" role="banner">
          <div id="header_logo">
            <a :href="$t('header_url')">
              <img id="hlogo_normal" src="@/assets/as_logo.svg" alt="Logo - Austrian Standards" />
              <img id="hlogo_icon" src="@/assets/as_logo-icon-only.svg" alt="Logo Icon - Austrian Standards" />
            </a>
          </div>
          <nav class="nav right">
            <LanguageSelector />
          </nav>
        </div>
      </div>
    </div>

    <!-- AI Header -->
    <div id="header_main" v-if="tenant === 'ai'">
      <div id="header_main_inner" class="container_as">
        <div id="header_main_alpha" role="banner">
          <div id="header_logo_ai">
            <a href="/de" class="text-left">
              <img id="hlogo_normal" src="@/assets/insure.png" alt="Logo - insure Academy" />
              <img id="hlogo_icon" src="@/assets/insure.png" alt="Logo Icon - insure Academy" />
            </a>
            <img
              src="@/assets/CertibleLogoR_minified_higher_precision.svg"
              alt="Logo Icon - Certible"
              class="float-right certible-logo--right"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- CMP Header -->
    <div id="header_main" v-if="tenant === 'cmp'">
      <div id="header_main_inner" class="container_cmp">
        <div id="header_main_alpha" role="banner">
          <div id="header_logo">
            <a href="https://www.customermanagementpractice.com/" class="text-left">
              <img id="hlogo_normal" src="@/assets/cmp_logo.png" alt="Logo - Customer Management Practice" />
              <img id="hlogo_icon" src="@/assets/cmp_logo.png" alt="Logo Icon - Customer Management Practice" />
            </a>
            <img
              src="@/assets/CertibleLogoR_minified_higher_precision.svg"
              alt="Logo Icon - Certible"
              class="float-right certible-logo--right"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Certible Header -->
    <div v-if="tenant === 'certible'">
      <header class="header">
        <div class="header-container">
          <div class="left">
            <a :href="certibleHomepageUrl" class="img-link" aria-label="Home">
              <img
                class="certible-logo"
                id="certible-logo"
                src="https://static.certible.com/logos/certible.svg"
                alt="Certible Logo"
                title="Certible Logo"
                width="150"
                height="48"
              />
            </a>
          </div>
          <nav class="nav right">
            <LanguageSelector />
          </nav>
        </div>
      </header>
    </div>

    <router-view></router-view>

    <div class="footer text-center text-label" v-if="tenant === 'as'">
      <a :href="$t('imprint.link')">{{ $t("imprint.text") }}</a>
      <a :href="$t('privacy_policy.link')">{{ $t("privacy_policy.text") }}</a>
    </div>

    <div class="footer text-center text-label" v-if="tenant === 'ai'">
      <a href="https://www.certible.com/de/Impressum/">Impressum</a>
      <a href="https://www.certible.com/de/Datenschutzerklaerung/">Datenschutzerklärung</a>
    </div>

    <!-- Certible Footer -->
    <footer class="footer--certible" v-if="tenant === 'certible'">
      <div class="footer-mobile-container container">
        <div class="footer-text">
          <p class="title">Contact</p>
          <p><a href="tel:+4313483993" linktype="url">+43 1 348 3993</a></p>
          <p><a href="mailto:contact@certible.com">contact@certible.com</a></p>
        </div>
      </div>
      <div class="site-container links-container container">
        <span>{{ year }} ® Certible GmbH</span>
        <a :href="$t('footer_privacy_policy_url')" class="home-link" target="_blank">{{
          $t("footer_privacy_policy_text")
        }}</a>
        <a :href="$t('footer_imprint_url')" class="home-link" target="_blank">{{ $t("footer_imprint_text") }}</a>
      </div>
    </footer>
  </div>
</template>

<script>
import LanguageSelector from "./LanguageSelector.vue";

export default {
  name: "RegistrationStart",

  components: {
    LanguageSelector,
  },
  computed: {
    certibleHomepageUrl() {
      if (this.locale === "de") {
        return "https://www.certible.com/de";
      }
      return "https://www.certible.com/";
    },
    year() {
      return new Date().getFullYear();
    },
    tenant() {
      return this.$store.getters["registration/tenant"];
    },
    uiColor() {
      return this.$store.getters["registration/uiColor"];
    },
    locale() {
      return this.$store.getters["registration/locale"];
    },
  },
  beforeCreate() {
    if (typeof window !== "undefined") {
      let urlParams = new URLSearchParams(window.location.search);
      if (process.env.VUE_APP_TENANT === "cmp") {
        this.$store.dispatch("registration/loadPersonalInfo", urlParams.get("id"));
        return;
      }
      if (
        urlParams.has("cert") ||
        urlParams.has("lang") ||
        urlParams.has("exam") ||
        urlParams.has("syllabus") ||
        urlParams.has("country")
      ) {
        if (urlParams.has("country_addr")) {
          this.$store.dispatch("registration/preloadExam", {
            cert: urlParams.get("cert"),
            lang: urlParams.get("lang"),
            exam: urlParams.get("exam"),
            country: urlParams.get("country"),
            country_addr: urlParams.get("country_addr"),
            syllabus: urlParams.get("syllabus"),
          });
        } else {
          this.$store.dispatch("registration/preloadExam", {
            cert: urlParams.get("cert"),
            lang: urlParams.get("lang"),
            exam: urlParams.get("exam"),
            country: urlParams.get("country"),
            syllabus: urlParams.get("syllabus"),
          });
        }
      } else {
        this.$store.dispatch("registration/loadSchemes");
      }
      if (urlParams.has("nd")) {
        this.$store.dispatch("registration/updateNextDayEnabled", true);
      }
      if (urlParams.has("trainer")) {
        this.$store.dispatch("registration/loadTrainerSettings", urlParams.get("trainer"));
      }
    }
  },
};
</script>

<style scoped>
#header_main {
  height: 120px;
  box-sizing: border-box;
  padding-top: 20px;
  border-bottom: 1px solid #d9dadb;
  box-shadow: 0 2px 4px 0 rgb(0 0 0 / 12%);
  z-index: 10;
  position: relative;
  margin-bottom: 56px;
}
#header_main_inner {
  height: 100%;
  display: flex;
  max-width: 1280px;
}
#header_main_alpha {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 20px;
}
#header_main_alpha_as {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
}
.container_as {
  width: 100%;
  padding-right: 16px;
  padding-left: 16px;
  margin-right: auto;
  margin-left: auto;
}
#header_logo {
  cursor: pointer;
}
@media (max-width: 960px) {
  #hlogo_normal {
    display: none;
  }
  #header_logo img {
    max-height: 30px;
    max-width: 30px;
  }
  #header_logo_ai img {
    max-width: 80px;
  }
  #header_main {
    height: 64px;
    padding: 0;
  }
  #header_main_alpha {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
    padding-bottom: 0;
    width: auto;
  }
  #header_main_alpha_as {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    padding-bottom: 0;
    width: 100%;
  }
}
@media (min-width: 960px) {
  #hlogo_icon {
    display: none;
  }
}
#header_logo img {
  width: 250px;
  height: auto;
  vertical-align: middle;
  border-style: none;
}
#header_logo_ai img {
  width: 170px;
  height: auto;
  vertical-align: middle;
  border-style: none;
}
.certible-logo--right {
  margin-top: 15px;
}
.container_cmp {
  width: 100%;
  padding-right: 16px;
  padding-left: 16px;
  margin-right: auto;
  margin-left: auto;
}

/* CERTIBLE HEADER WEBSITE STYLES */
.certible-logo {
  width: 150px;
  height: 48px;
}
.header {
  background-color: white;
  width: 100%;
  /*background: linear-gradient(to top, rgba(256, 256, 256, 0), rgba(256, 256, 256, 1));*/
}
.header > .header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.header-container {
  max-width: 1300px;
  margin: 0 auto;
  padding: 0 1rem;
  height: 4rem;
  margin-top: 0.5rem;
}
.footer--certible {
  width: 100%;
  position: absolute;
  z-index: 1;
  /*min-height: 36rem;*/
  padding-top: 0;
  background: linear-gradient(35deg, rgb(69, 69, 69) 0%, rgb(98, 68, 68) 39%, rgb(152, 152, 152) 100%);
  color: #fff;
  bottom: 0;
}
.footer-mobile-container {
  width: 100%;
  margin: 0 auto;
  padding: 0 1rem;
  max-width: 1300px;
}
.container {
  z-index: 1 !important;
  background-color: unset !important;
  position: unset !important;
}
.footer-text .title {
  margin-bottom: 0.7rem;
  margin-top: 1.5rem;
  font-size: 1.5rem;
  color: #fff;
}
.footer-text p a {
  text-decoration: underline;
  color: #fff;
}
.footer-text p {
  font-weight: 500;
  margin-bottom: 0.5rem;
}
.site-container {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  padding: 0 1rem;
  max-width: 1300px;
}
.links-container {
  font-size: 1rem;
  width: 100%;
  margin: 1rem auto 0.2rem auto;
  padding: 0 1rem;
  max-width: 1300px;
}
.links-container a {
  text-decoration: underline;
  color: #fff !important;
}
.home-link {
  text-decoration: none;
}
@media (max-width: 960px) {
  .site-container {
    flex-direction: column;
  }
}
@media (min-width: 960px) {
  .header-container {
    padding: 0 6rem;
  }
  .header-container {
    height: 6rem;
    background-color: white;
  }
  .header {
    height: fit-content;
    z-index: 10;
  }
}
</style>
